import React from 'react'
import { Tag } from 'antd'
import PropTypes from 'prop-types'
import styles from './styles'

const UserTypes = ({ userTypes }) => {
  return (
    <div className={styles.tag_wrapper}>
      {userTypes.map(({ name, uuid }) => {
        return uuid &&
          <Tag
            className={styles.tag}
            key={uuid}
          >
            {name.toUpperCase()}
          </Tag>
      })}
    </div>
  )
}

UserTypes.propTypes = {
  userTypes: PropTypes.array
}

export default UserTypes
